import { CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, Tab, Tabs, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import FileUploadIcon from '@mui/icons-material/FileUpload';
import Button from '../../components/Button';
import { question as questionConstant } from './constants';
import { Info, X } from '@phosphor-icons/react';
import { useParams } from 'react-router-dom';
import { toast as toastFn } from 'react-toastify';
import { audioFileFilter, imageFileFilter, videoFileFilter } from '../../utils';
import { uploadImage } from '../../store/questionBank/questionBankBaseApi';
import { MediaPreview } from './MediaPreview';

const Layout = ({ type, details, setDetails, question, answerKey, helpText, mtf, mcq, selectedStyle, selectedTemplate, selected }) => {

  const { id } = useParams();
  const mediaTypes = ['link', 'upload'];
  const [loading, setLoading] = useState(false);
  const [abortController, setAbortController] = useState(null);
  const [selectedTab, setSelectedTab] = useState(1);
  const [displayText, setDisplayText] = useState('');
  const textAreaRef = useRef(null);
  const [mediaPreview, setMediaPreview] = useState(false);
  const [currentContentUrl, setCurrentContentUrl] = useState(null);
  const [currentContentType, setCurrentContentType] = useState(null);

  useEffect(() => {
    if (selectedStyle && selectedTemplate) {
      setDetails(prevDetails => ({
        ...prevDetails,
        style: selectedStyle,
        displayTemplate: selectedTemplate,
      }));
    }
  }, [selected]);
  // useEffect(() => {
  //   if (selectedStyle && selectedTemplate) {
  //     setDetails(prevQuestion => ({
  //       ...prevQuestion,
  //       style: selectedStyle,
  //       displayTemplate: selectedTemplate
  //     }));
  //   }
  // }, [selectedStyle, selectedTemplate])


  const handleMediaPreview = (url, type) => {
    setCurrentContentUrl(url);
    setCurrentContentType(type);
    setMediaPreview(!mediaPreview);
  };

  const handlePreviewClose = () => {
    setCurrentContentUrl(null);
    setCurrentContentType(null);
    setMediaPreview(!mediaPreview)
  }

  const handleChange = (e) => {
    const { name, value } = e.target;

    setDetails(prevQuestion => ({
      ...prevQuestion,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (details?.text) {
      setDisplayText(details.text.replace(/{(\d{1,2})}/g, 'blank($1)'));
    }
  }, [details?.text]);
  const handleChangeFill = (e) => {
    const { name, value } = e.target;

    if (name === 'text') {
      setDisplayText(value);
      const formattedText = value.replace(/blank\((\d{1,2})\)/g, (_, p1) => `{${p1}}`);
      setDetails(prevQuestion => ({
        ...prevQuestion,
        text: formattedText,
      }));
    }
  }

  const handleAddBlank = () => {
    const input = textAreaRef.current;
    if (input) {
      const cursorPosition = input.selectionStart;
      const textBeforeCursor = displayText.slice(0, cursorPosition);
      const textAfterCursor = displayText.slice(cursorPosition);
      const blankPlaceholder = `blank()`;

      setDisplayText(textBeforeCursor + blankPlaceholder + textAfterCursor);

      setTimeout(() => {
        input.setSelectionRange(cursorPosition + 6, cursorPosition + 6);
        input.focus();
      }, 0);
    }
  };


  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const showToast = (msg, type) => {
    if (!type) {
      return toastFn(msg);
    }
    toastFn[type](msg);
  }
  const onFileChange = async (file) => {
    const fileSizeInMB = (file.size / 1024 / 1024)
    if (details?.style == 'text-and-video') {
      if (!videoFileFilter(file.name)) {
        return showToast('Please upload a valid file', 'error');
      } else if (fileSizeInMB > 20) {
        return showToast('Please upload file with in the 20 MB video', 'error');
      }
    } else if (details?.style == 'text-and-audio') {
      if (!audioFileFilter(file.name)) {
        return showToast('Please upload a valid file', 'error');
      } else if (fileSizeInMB > 20) {
        return showToast('Please upload file with in the 20 MB video', 'error');
      }
    } else if (details?.style == 'text-and-image') {
      if (!imageFileFilter(file.name)) {
        return showToast('Please upload a valid file', 'error');
      } else if (fileSizeInMB > 5) {
        return showToast('Please upload file with in the 5 MB', 'error');
      }
    }
    'THU'
    const formData = new FormData();
    formData.append('file', file);

    const controller = new AbortController();
    setAbortController(controller);
    try {
      setLoading(true);
      const resp = await uploadImage({ id, formData, type, signal: controller.signal });
      if (resp.data) {
        setDetails({ ...details, contentURL: resp.data })
      }
      if (resp.message) {
        showToast(resp.message, 'success');
      }
    } catch (e) {
      return showToast(e.error, 'error');
    } finally {
      setLoading(false);
      setAbortController(null);
    }
  }

  const handleCancelUpload = () => {
    if (abortController) {
      abortController.abort();
      setAbortController(null);
      setLoading(false);
    }
  }

  const renderQuestionFields = () => {
    switch (details?.style) {
      case 'text':
        return <>
          {type === 'FIB' ?
            <Grid item xs={12}>
              <InputLabel style={styles.inputLabel}>Text  </InputLabel>
              <Button onClick={handleAddBlank} size="small" color="primary" placeholder={' Add Blank'} />
              <Tooltip title="Mention the no. of character in ( ) only two digits.">
                <Info />
              </Tooltip>
              <TextField
                name='text'
                fullWidth
                multiline
                rows={3}
                disabled={type === 'show'}
                value={displayText}
                onChange={(e) => handleChangeFill(e)}
                placeholder={`Enter Your Question`}
                inputRef={textAreaRef}
              />
            </Grid>
            :
            <Grid item xs={12}>
              <InputLabel style={styles.inputLabel}>Text</InputLabel>
              <TextField
                name='text'
                fullWidth
                multiline
                rows={3}
                disabled={type === 'show'}
                value={details?.text}
                onChange={(e) => handleChange(e)}
                placeholder={question ? `Enter Your Question` : answerKey ? 'Enter the Answer Key' : helpText ? 'Enter the Help Text' : 'Enter the Answer Option'}
              />
            </Grid>}
        </>
      case 'text-and-image':
        return <>
          {type === 'FIB' ?
            <Grid item xs={12}>
              <InputLabel style={styles.inputLabel}>Text  </InputLabel>
              <Button onClick={handleAddBlank} size="small" color="primary" placeholder={' Add Blank'} />
              <Tooltip title="Mention the no. of character in ( ) only two digits.">
                <Info />
              </Tooltip>
              <TextField
                name='text'
                fullWidth
                multiline
                rows={3}
                disabled={type === 'show'}
                value={displayText}
                onChange={(e) => handleChangeFill(e)}
                placeholder={`Enter Your Question`}
                inputRef={textAreaRef}
              />
            </Grid>
            :
            <Grid item xs={12}>
              <InputLabel style={styles.inputLabel}>Text</InputLabel>
              <TextField
                name='text'
                fullWidth
                multiline
                rows={3}
                disabled={type === 'show'}
                value={details?.text}
                onChange={(e) => handleChange(e)}
                placeholder={question ? `Enter Your Question` : answerKey ? 'Enter the Answer Key' : helpText ? 'Enter the Help Text' : 'Enter the Answer Option'}
              />
            </Grid>
          }
          <Grid item xs={12} sx={{ mt: 2 }}>
            <Typography
              align="left"
              variant="h6"
              color="primary.blue"
              sx={{
                margin: '0',
                fontWeight: '700',
                lineHeight: '1.5',
                display: 'flex',
                alignItems: 'center'
              }}>Media
              <Tooltip title="Provide link or Upload file">
                <Info style={{ fontSize: '16px', cursor: 'pointer' }} />
              </Tooltip>
            </Typography>
          </Grid>
          {type === "show" ?
            <Grid item xs={12}>
              <Button onClick={() => handleMediaPreview(details?.contentURL, 'text-and-image')} variant="contained" size="small" color="primary" placeholder={' View Image'} />

              <MediaPreview
                contentURL={currentContentUrl}
                contentType={currentContentType}
                handleClose={handlePreviewClose}
                mediaPreview={mediaPreview}
              />
            </Grid>
            :
            <>
              <Grid item xs={12}>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                >
                  {mediaTypes.map((item, index) => (
                    <Tab label={item} key={index} />
                  ))}
                </Tabs>
              </Grid>
              {selectedTab === 0 && (
                <Grid item xs={12} md={mtf ? 12 : 6}>
                  <InputLabel style={styles.inputLabel}>URL</InputLabel>
                  <Grid container alignItems="center">
                    <Grid item xs={11}>
                      <TextField
                        name="contentURL"
                        fullWidth
                        value={details?.contentURL || ''}
                        placeholder={'Enter Media Link'}
                        onChange={(e) => handleChange(e)}
                        disabled={type === 'show'}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {selectedTab === 1 && (
                <Grid item xs={12} md={mtf ? 12 : 6}>
                  <InputLabel style={styles.inputLabel}>
                    Image
                  </InputLabel>
                  <span style={{ color: 'grey', fontSize: '0.8em', fontWeight: 500 }}>
                    (Upload image files in <span style={{ color: '#000' }}>.jpg, .jpeg, .png, .gif</span> format up to <span style={{ color: '#000' }}>5MB</span> in Size)
                  </span>
                  <Grid container alignItems="center">
                    <Grid item xs={11}>
                      <TextField
                        name="contentURL"
                        fullWidth
                        value={details?.contentURL || ''}
                        placeholder={'Select image'}
                        disabled
                      />
                    </Grid>
                    {type !== 'show' &&
                      <Grid item xs={1}>
                        {loading && <CircularProgress size="30px" />}
                        {!loading && <FileUploadBtn onFileSelect={(file) => onFileChange(file)} fileType="image" />}
                      </Grid>}
                    {loading &&
                      <Button
                        size="small"
                        variant="outlined"
                        color="error"
                        sx={{
                          mt: 2,
                          fontSize: '0.8rem',
                        }}
                        onClick={handleCancelUpload}
                        placeholder={<div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}><X /> Cancel </div>}
                      />}

                  </Grid>
                </Grid>)}

            </>}
        </>
      case 'text-and-audio':
        return <>
          {type === 'FIB' ?
            <Grid item xs={12}>
              <InputLabel style={styles.inputLabel}>Text  </InputLabel>
              <Button onClick={handleAddBlank} size="small" color="primary" placeholder={' Add Blank'} />
              <Tooltip title="Mention the no. of character in ( ) only two digits.">
                <Info />
              </Tooltip>
              <TextField
                name='text'
                fullWidth
                multiline
                rows={3}
                disabled={type === 'show'}
                value={displayText}
                onChange={(e) => handleChangeFill(e)}
                placeholder={`Enter Your Question`}
                inputRef={textAreaRef}
              />
            </Grid>
            :
            <Grid item xs={12}>
              <InputLabel style={styles.inputLabel}>Text</InputLabel>
              <TextField
                name='text'
                fullWidth
                multiline
                rows={3}
                disabled={type === 'show'}
                value={details?.text}
                onChange={(e) => handleChange(e)}
                placeholder={question ? `Enter Your Question` : answerKey ? 'Enter the Answer Key' : helpText ? 'Enter the Help Text' : 'Enter the Answer Option'}
              />
            </Grid>
          }
          <Grid item xs={12} sx={{ mt: 2 }}>
            <Typography
              align="left"
              variant="h6"
              color="primary.blue"
              sx={{
                margin: '0',
                fontWeight: '700',
                lineHeight: '1.5',
              }}>Media
              <Tooltip title="Provide link or Upload file">
                <Info style={{ fontSize: '16px', cursor: 'pointer' }} />
              </Tooltip>
            </Typography>
          </Grid>
          {type === "show" ?
            <Grid item xs={12}>
              <Button onClick={() => handleMediaPreview(details?.contentURL, 'text-and-audio')} variant="contained" size="small" color="primary" placeholder={' Play Audio'} />

              <MediaPreview
                contentURL={currentContentUrl}
                contentType={currentContentType}
                handleClose={handlePreviewClose}
                mediaPreview={mediaPreview}
              />
            </Grid>
            :
            <>
              <Grid item xs={12} >
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                >
                  {mediaTypes.map((item, index) => (
                    <Tab label={item} index={index} />
                  ))}
                </Tabs>
              </Grid>
              {selectedTab === 0 && (
                <Grid item xs={12} md={mtf ? 12 : 6}>
                  <InputLabel style={styles.inputLabel}>URL</InputLabel>
                  <Grid container alignItems="center">
                    <Grid item xs={11}>
                      <TextField
                        name="contentURL"
                        fullWidth
                        value={details?.contentURL || ''}
                        placeholder={'Enter Media Link'}
                        onChange={(e) => handleChange(e)}
                        disabled={type === 'show'}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {selectedTab === 1 && (
                <Grid item xs={12} md={mtf ? 12 : 6}>
                  <InputLabel style={styles.inputLabel}>
                    Audio
                  </InputLabel>
                  <span style={{ color: 'grey', fontSize: '0.8em', fontWeight: 500 }}>
                    (Upload audio files in <span style={{ color: '#000' }}>.mp3, .wav</span> format up to <span style={{ color: '#000' }}>20MB</span> in Size)
                  </span>
                  <Grid container alignItems="center">
                    <Grid item xs={11}>
                      <TextField
                        name="contentURL"
                        fullWidth
                        value={details?.contentURL || ''}
                        placeholder={'Select Audio'}
                        disabled
                      />
                    </Grid>
                    {type !== 'show' &&
                      <Grid item xs={1}>
                        {loading && <CircularProgress size="30px" />}
                        {!loading && <FileUploadBtn onFileSelect={(file) => onFileChange(file)} fileType="audio" />}
                      </Grid>}
                    {loading &&
                      <Button
                        size="small"
                        variant="outlined"
                        color="error"
                        sx={{
                          mt: 2,
                          fontSize: '0.8rem',
                        }}
                        onClick={handleCancelUpload}
                        placeholder={<div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}><X /> Cancel </div>}
                      />}
                  </Grid>
                </Grid>)}
            </>}
        </>
      case 'text-and-video':
        return <>
          {type === 'FIB' ?
            <Grid item xs={12}>
              <InputLabel style={styles.inputLabel}>Text  </InputLabel>
              <Button onClick={handleAddBlank} size="small" color="primary" placeholder={' Add Blank'} />
              <Tooltip title="Mention the no. of character in ( ) only two digits.">
                <Info />
              </Tooltip>
              <TextField
                name='text'
                fullWidth
                multiline
                rows={3}
                disabled={type === 'show'}
                value={displayText}
                onChange={(e) => handleChangeFill(e)}
                placeholder={`Enter Your Question`}
                inputRef={textAreaRef}
              />
            </Grid>
            :
            <Grid item xs={12}>
              <InputLabel style={styles.inputLabel}>Text</InputLabel>
              <TextField
                name='text'
                fullWidth
                multiline
                rows={3}
                disabled={type === 'show'}
                value={details?.text}
                onChange={(e) => handleChange(e)}
                placeholder={question ? `Enter Your Question` : answerKey ? 'Enter the Answer Key' : helpText ? 'Enter the Help Text' : 'Enter the Answer Option'}
              />
            </Grid>
          }
          <Grid item xs={12} sx={{ mt: 2 }}>
            <Typography
              align="left"
              variant="h6"
              color="primary.blue"
              sx={{
                margin: '0',
                fontWeight: '700',
                lineHeight: '1.5',
              }}>Media
              <Tooltip title="Provide link or Upload file">
                <Info style={{ fontSize: '16px', cursor: 'pointer' }} />
              </Tooltip>
            </Typography>
          </Grid>
          {type === "show" ?
            <Grid item xs={12}>
              <Button onClick={() => handleMediaPreview(details?.contentURL, 'text-and-video')} variant="contained" size="small" color="primary" placeholder={' Play Video'} />

              <MediaPreview
                contentURL={currentContentUrl}
                contentType={currentContentType}
                handleClose={handlePreviewClose}
                mediaPreview={mediaPreview}
              />
            </Grid>
            :
            <>
              <Grid item xs={12}>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                >
                  {mediaTypes.map((item, index) => (
                    <Tab label={item} key={index} />
                  ))}
                </Tabs>
              </Grid>
              {selectedTab === 0 && (
                <Grid item xs={12} md={mtf ? 12 : 6}>
                  <InputLabel style={styles.inputLabel}>URL</InputLabel>
                  <Grid container alignItems="center">
                    <Grid item xs={11}>
                      <TextField
                        name="contentURL"
                        fullWidth
                        value={details?.contentURL || ''}
                        placeholder={'Enter Media Link'}
                        onChange={(e) => handleChange(e)}
                        disabled={type === 'show'}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {selectedTab === 1 && (
                <Grid item xs={12} md={mtf ? 12 : 6}>
                  <InputLabel style={styles.inputLabel}>
                    Video
                  </InputLabel>
                  <span style={{ color: 'grey', fontSize: '0.8em', fontWeight: 500 }}>
                    (Upload video files in <span style={{ color: '#000' }}>.mp4, .mov, .wmv, .avi, .mkv</span> format up to <span style={{ color: '#000' }}>20MB</span> in Size)
                  </span>
                  <Grid container alignItems="center">
                    <Grid item xs={11}>
                      <TextField
                        name="contentURL"
                        fullWidth
                        value={details?.contentURL || ''}
                        placeholder={'Select Video'}
                        disabled
                      />
                    </Grid>
                    {type !== 'show' &&
                      <Grid item xs={1}>
                        {loading && <CircularProgress size="30px" />}
                        {!loading && <FileUploadBtn onFileSelect={(file) => onFileChange(file)} fileType="video" />}
                      </Grid>}
                    {loading &&
                      <Button
                        size="small"
                        variant="outlined"
                        color="error"
                        sx={{
                          mt: 2,
                          fontSize: '0.8rem',
                        }}
                        onClick={handleCancelUpload}
                        placeholder={<div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}><X /> Cancel </div>}
                      />}
                  </Grid>
                </Grid>)}
            </>}
        </>
      default:
        return <>
          <Grid item xs={12}>
            Please Select Skills and Display Template
          </Grid>
        </>
    }
  }

  const renderLayoutFields = () => {
    switch (type) {
      case 'show':
        return <>
          <Grid sx={styles.gridContainer} container spacing={2} alignItems="center">
            <Grid
              item
              xs={mtf ? 6 : 12}
              sm={mtf ? undefined : 6}
              md={mtf ? undefined : 4}
              lg={mtf ? undefined : 3}
            >
              <InputLabel style={styles.inputLabel}>Style</InputLabel>
              <FormControl fullWidth>
                <Select
                  name="style"
                  value={details?.style || ''}
                  onChange={(e) => handleChange(e)}
                  placeholder="Style"
                  disabled
                  sx={{ height: '47px' }}
                >
                  <MenuItem value=""><em>None</em></MenuItem>
                  {Object.keys(questionConstant.STYLES).map((key, i) => <MenuItem key={i} value={key}>{questionConstant.STYLES[key]}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={mtf ? 6 : 12}
              sm={mtf ? undefined : 6}
              md={mtf ? undefined : 4}
              lg={mtf ? undefined : 3}
            >
              <InputLabel style={styles.inputLabel}>Display Template</InputLabel>
              <FormControl fullWidth>
                <Select
                  name="displayTemplate"
                  value={details?.displayTemplate || ''}
                  onChange={(e) => handleChange(e)}
                  placeholder="Display Template"
                  disabled
                  sx={{ height: '47px' }}
                >
                  <MenuItem value=""><em>None</em></MenuItem>
                  {questionConstant.DISPLAY_TEMPLATE.map((item, index) => {
                    return <MenuItem key={index} value={item}>{item}</MenuItem>
                  })}
                </Select>
              </FormControl>
            </Grid>
            {details?.style && details?.displayTemplate &&
              renderQuestionFields()
            }
          </Grid>
        </>
      default:
        return <>
          <Grid sx={styles.gridContainer} container spacing={2} alignItems="center">
            <Grid
              item
              xs={mtf ? 6 : 12}
              sm={mtf ? undefined : 6}
              md={mtf ? undefined : 4}
              lg={mtf ? undefined : 3}
              sx={{ display: mcq && 'none' || mtf && 'none' }}
            >
              <InputLabel style={styles.inputLabel}>Style</InputLabel>
              <FormControl fullWidth>
                <Select
                  name="style"
                  value={details?.style || ''}
                  onChange={(e) => handleChange(e)}
                  placeholder="Style"
                  sx={{ height: '47px' }}
                  disabled={selectedStyle || selectedTemplate}
                >
                  <MenuItem value=""><em>None</em></MenuItem>
                  {Object.keys(questionConstant.STYLES).map((key, i) => <MenuItem key={i} value={key}>{questionConstant.STYLES[key]}</MenuItem>)}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={mtf ? 6 : 12}
              sm={mtf ? undefined : 6}
              md={mtf ? undefined : 4}
              lg={mtf ? undefined : 3}
              sx={{ display: mcq && 'none' || mtf && 'none' }}
            >
              <InputLabel style={styles.inputLabel}>Display Template</InputLabel>
              <FormControl fullWidth>
                <Select
                  name="displayTemplate"
                  value={details?.displayTemplate || ''}
                  onChange={(e) => handleChange(e)}
                  placeholder="Display Template"
                  sx={{ height: '47px' }}
                  disabled={selectedStyle || selectedTemplate}
                >
                  <MenuItem value=""><em>None</em></MenuItem>
                  {questionConstant.DISPLAY_TEMPLATE.map((item, index) => {
                    return <MenuItem key={index} value={item}>{item}</MenuItem>
                  })}
                </Select>
              </FormControl>
            </Grid>
            {details?.style && details?.displayTemplate &&
              renderQuestionFields()
            }
          </Grid>
        </>
    }
  }


  return (
    <React.Fragment>
      {renderLayoutFields()}
    </React.Fragment>
  )
}

const FileUploadBtn = ({ onFileSelect, fileType }) => {
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      onFileSelect(file);
    }
  };

  const getAcceptedFormats = () => {
    switch (fileType) {
      case "image":
        return ".jpg, .jpeg, .png, .gif";
      case "video":
        return ".mp4, .mov, .wmv, .avi, .mkv";
      case "audio":
        return ".mp3, .wav";
      default:
        return "*"; // Allow all types if no specific type is defined
    }
  };

  return (
    <div>
      <Button style={styles.uploadBtn} variant='contained' placeholder={<FileUploadIcon sx={{ color: 'var(--mui-palette-primary-blue)' }} />} onClick={handleButtonClick} />
      <input
        type="file"
        style={styles.hiddenInput}
        ref={fileInputRef}
        onChange={handleFileSelect}
        accept={getAcceptedFormats()} // Set accepted file formats dynamically
      />
    </div>
  );
};

const styles = {
  label: {
    color: 'var(--mui-palette-common-black)',
    fontWeight: 'bold'
  },
  inputLabel: {
    color: 'var(--mui-palette-primary-darkGrey)',
    marginBottom: '5px',
    fontWeight: '600',
    fontSize: '14px'

  },
  gridContainer: {
    mt: 1,
  },
  suggestionBox: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginTop: '10px',
  },
  suggestionItem: {
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '2px',
    cursor: 'pointer',
    boxShadow: '0 4px 8px var(--mui-palette-secondary-boxShadow1)',
    backgroundColor: 'var(--mui-palette-gray-lightGrey300)',
  },
  uploadBtn: {
    width: '30px',
    height: '30px',
    boxShadow: 'none',
    border: 'none',
    backgroundColor: 'transparent',
    padding: 0,
    borderRadius: '0',
    minWidth: '30px'
  },
  hiddenInput: {
    display: 'none',
  }
};

export default Layout